@if ((canReadPage$ | async) && !linkDisabled) {
    <a class="text-nowrap"
       [routerLink]="(href$ | async)?.path"
       [queryParams]="(href$ | async)?.queryParams"
       adaptTooltip="Go to the {{ linkTooltipName }} objectives page">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        {{ linkText }}
        <adapt-team-private-icon [team]="team"
                                 [showTooltip]="false"></adapt-team-private-icon>
    </a>
} @else {
    <span>
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        {{ linkText }}
    </span>
}

<ng-template #icon>
    @if (team) {
        <adapt-link-team class="me-n1"
                         [team]="team"
                         [showIcon]="true"
                         [smallIcon]="true"
                         [showName]="false"
                         [showIconTooltip]="linkDisabled"></adapt-link-team>
    } @else {
        <i [ngClass]="linkIcon"></i>
    }
</ng-template>
